export default {
	screen: "loading",
	downloadTime: new Date() - cabchargeHtmlLoaded,
	splashTimeout: 1000 - (new Date() - cabchargeHtmlLoaded),
	downloadTimeout: 30000
};